<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div>
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">                     
                            <div class="modal-body ">
                                <div class="title_block">
                                    <h3 class="mb-0 font-active">{{ title }}: <span>{{item.profile}}</span> </h3>
                                    <span @click="notOpenModal"><SvgHeaderSvg type="close" class="largesvg" /></span>
                                </div>
                                <div class="mt-3">
                                    <p>A ring’s profile can be low or high. This refers to how the center stone sits on the band.</p>

                                    <div class="image_block my-2 text-center">
                                        <div @click="setActive('low')" :class="{ active: activeSpread === 'low' }">
                                          <img width="150" height="72" v-show="activeSpread !== 'low'" src="~/assets/presetdetails/low.svg" alt="Low" />
                                          <img width="150" height="72" v-show="activeSpread === 'low'" src="/settingactive/low.svg" alt="Low" />
                                          <p :class="{ 'inactive': activeSpread !== 'low', 'active-text': activeSpread === 'low' }">Low</p>
                                        </div>
                                      
                                      
                                        <div @click="setActive('high')" :class="{ active: activeSpread === 'High' }">
                                          <img width="150" height="72" v-show="activeSpread !== 'high'" src="/loose_setting/high.svg" alt="High" />
                                          <img width="150" height="72" v-show="activeSpread === 'high'" src="/settingactive/high.svg" alt="High" />
                                          <p :class="{ 'inactive': activeSpread !== 'high', 'active-text': activeSpread === 'high' }">High</p>
                                        </div>
                                    </div>
                                    <p class="mb-0" v-if="activeSpread === 'high'">In a high-profile setting, the diamond sits elevated on the finger, offering greater visibility for the diamond. It pairs beautifully with multiple matching bands for a stunning stacked look.</p>
                                    <p class="mb-0" v-if="activeSpread === 'low'">In a low profile setting, the center stone securely sits closer to the finger, offering a sleeker, more subtle look. It pairs beautifully with curved, chevron bands or other low profile bands.</p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Teleport>
        </div>
    </div>
   
</template>

<script setup>
    const flagShowModal = ref(false);
    const profileRef = ref(null);
    const props = defineProps(['item','title','ringBox'])

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = profileRef.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = profileRef.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    const activeSpread = ref(props.item.profile)
        watch(() => props.item.profile, (newValue) => {
            activeSpread.value = newValue;
    
        });

    const setActive = (spread) => {
        nextTick(() => {
        activeSpread.value = spread;
    });

    };
</script>


<style scoped>
.largesvg {
    transform: scale(1.3);
    }

.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
}

p {
    font-size: 16px;
    color: #606060;
}
h3{
    font-size: 22px;
}
.image_block{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.image_block p{
    font-size: 16px;
    color: #668b84;
    font-weight: 600;
    text-decoration: underline;
}
.image_block .inactive {
    color: #909090;
  }
  .image_block .active-text {
    color: var(--green);
}
.title_block span {
    cursor: pointer;
    color: var(--green);
}
.title{
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;

}
.m-info {
    margin: 10px 0;
}
@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }


}
</style>

